module.exports = __webpack_public_path__ + "img/builder-32.18877d78.webp";